// extracted by mini-css-extract-plugin
export var hidden = "_ni-1";
export var visible = "_ni-0";